import {CampaignType} from '../campaigns/campaigns.types';
import {DSPType} from './dsp.types';
import apiV2Service from '../api/api-v2.service';
import {JobExecutionParams} from '../jobs/jobs.types';
import waitForJob from '../jobs/utils/waitForJob';

const BAST_PATH = 'Dsp';

async function pullPlacementsFromDSP({
  campaignId,
  campaignVersionId,
  campaignIntegrationIds,
  jobTitle = 'Synchronize DSP Placements',
}: {
  campaignId: number;
  campaignIntegrationIds: number[];
  campaignVersionId?: number;
  jobTitle?: string;
}) {
  const {data: syncJobs} = await apiV2Service.executePostRequest<JobExecutionParams[]>(
    `${BAST_PATH}/PullPlacementsFromDSP`,
    {},
    {
      campaignId,
      campaignVersionId,
      campaignIntegrationIds,
    },
  );

  return await Promise.all(
    syncJobs
      .filter((job) => !!job.executionId)
      .map((job) =>
        waitForJob({
          jobId: job.executionId,
          jobName: jobTitle,
        }),
      ),
  );
}

async function getAll(params: {campaignType?: CampaignType}) {
  const url = `${BAST_PATH}/GetAll`;

  const {data} = await apiV2Service.executeGetRequest<{dsps: DSPType[]}>(url, params);

  return data.dsps.filter((dsp) => !dsp.isDeprecated);
}

async function getParametersForPublisher(params: {campaignId: number; publisherId: string}) {
  const {data} = await apiV2Service.executeGetRequest<number[]>(
    `${BAST_PATH}/GetParametersForPublisher/${params.campaignId}`,
    {
      publisherId: params.publisherId,
    },
  );

  return data;
}

export const dspApi = {
  pullPlacementsFromDSP,
  getAll,
  getParametersForPublisher,
};
